import React from "react";

const LABELS = {
  healthy: "Healthy",
  moderate: "Moderate",
  low: "Low",
  active: "Active",
  idle: "Idle",
  dormant: "Dormant",
};

export function HealthBadge({ health }) {
  if (!health) return null;
  const key = String(health).toLowerCase();
  return (
    <span className={`ou-pill ou-pill--${key}`}>{LABELS[key] || health}</span>
  );
}
